import { Observable } from "rxjs";
import { EmailAccountDelegate } from "./email-account.delegate";
import
{
    IEmailProvider,
    IEmailAccountStatus,
    IEmailAccountConnectResult,
    ISendEmailRequest,
    IInboxResult,
    IInboxMessageDetail,
    ICalendarInviteRequest,
    ICalendarInviteResult,
    ICalendarInviteStatusResult
} from "./email-account.interface";

export class EmailAccountService
{
    constructor(private emailAccountDelegate: EmailAccountDelegate)
    {
    }

    public getProviders(): Observable<IEmailProvider[]>
    {
        return this.emailAccountDelegate.getProviders();
    }

    public getStatus(): Observable<IEmailAccountStatus>
    {
        return this.emailAccountDelegate.getStatus();
    }

    public connect(provider: number): Observable<IEmailAccountConnectResult>
    {
        return this.emailAccountDelegate.connect(provider);
    }

    public disconnect(): Observable<boolean>
    {
        return this.emailAccountDelegate.disconnect();
    }

    public getInbox(top: number, skip: number, pageToken?: string): Observable<IInboxResult>
    {
        return this.emailAccountDelegate.getInbox(top, skip, pageToken);
    }

    public getInboxMessage(messageId: string): Observable<IInboxMessageDetail>
    {
        return this.emailAccountDelegate.getInboxMessage(messageId);
    }

    public replyToMessage(messageId: string, htmlBody: string, replyAll: boolean): Observable<boolean>
    {
        return this.emailAccountDelegate.replyToMessage(messageId, htmlBody, replyAll);
    }

    public sendEmail(email: ISendEmailRequest): Observable<boolean>
    {
        return this.emailAccountDelegate.sendEmail(email);
    }

    public sendCalendarInvite(invite: ICalendarInviteRequest): Observable<ICalendarInviteResult>
    {
        return this.emailAccountDelegate.sendCalendarInvite(invite);
    }

    public getCalendarInviteStatus(providerEventId: string): Observable<ICalendarInviteStatusResult>
    {
        return this.emailAccountDelegate.getCalendarInviteStatus(providerEventId);
    }
}
